// Makes it harder to save images from the public site (right-click, drag, long-press).
// Not applied on /admin so the owner can work normally.
export function enableImageProtection() {
  const isProtected = (target: EventTarget | null) => {
    if (window.location.pathname.startsWith("/admin")) return false;
    return target instanceof HTMLElement && (target.tagName === "IMG" || target.tagName === "PICTURE" || target.tagName === "VIDEO" || !!target.closest("[data-protect-image]"));
  };
  const block = (e: Event) => {
    if (isProtected(e.target)) e.preventDefault();
  };
  document.addEventListener("contextmenu", block);
  document.addEventListener("dragstart", block);
}
